// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"36909":"977d254759e4e40e83ff","82800":"640b0c4dcc30584e7625"}[chunkId] + ".min.css";
};